import * as React from 'react';
import { safeNumericString } from 'app/infrastructure/data/sanitize';
import { deserializeConnectionState } from 'app/area/case/draft/connected-state';
import { Bowtie } from './bowtie';
import { BowtieDisplayMode } from './external-types';
import { withRouter, WithRouterProps } from 'app/components/enhancers/with-router';
import { useInstanceKey } from 'app/area/favourite/favourite-context';
import { Case } from 'app/area/case';
import { CaseViewModal } from 'app/area/case/components/case-view-modal';
import { Outlet, useOutletContext } from 'react-router-dom';

interface BowtieParams {
  id: string;
}

const CaseWithRouter = withRouter(Case);

export const BowtieScreen: React.FC<React.PropsWithChildren<BowtieParams & WithRouterProps>> = (props) => {

  const caseNumber = safeNumericString(props.params.bowtieCaseId);
  const connectedDrafts = deserializeConnectionState(props.router.location.query);
  const instanceKey = useInstanceKey();

  if (caseNumber === '') {
    return null;
  }

  return (
    <div>
      <Bowtie
        caseNumber={caseNumber}
        connectedDrafts={connectedDrafts}
        favouriteId={undefined}
        instanceKey={instanceKey}
        displayMode={BowtieDisplayMode.fullscreen}
      />
      <Outlet context={{ bowtieCaseId: caseNumber }} />
    </div>
  );
};

export const BowtieCaseViewModal = () => {
  const { bowtieCaseId } = useOutletContext<{ bowtieCaseId: number }>();
  return (
    <CaseViewModal bowtieCaseId={bowtieCaseId}>
      <CaseWithRouter />
    </CaseViewModal>
  );
};
